<template>
  <div :class="full_screan ? 'carousel_full' : 'carrocel'">
    <div class="ative-area d-flex flex-column justify-content-between">
      <div class="d-flex justify-content-end py-2 px-3">
        <button @click="full_screan = !full_screan" class="btn-full-image">
          <i class="icon" :class="full_screan ? 'icon-close' : ' icon-expand-image' " ></i>
        </button>
      </div>
      <div class="d-flex justify-content-between h-100 w-100">
        <div class="btn-area p-3">
          <button class="btn" @click.prevent="backImage">
            <i class="icon icon-arrow-back m-0"></i>
          </button>
        </div>
        <section class="d-flex align-items-end">
          <ul class="indicators d-flex p-2 rounded">
            <li v-for="(item, i) in images" :key="i">
              <div
                class="indicator m-1"
                :class="i === current_index ? 'selected' : ''"
              ></div>
            </li>
          </ul>
        </section>

        <div class="btn-area p-3">
          <button class="btn" @click.prevent="nextImage">
            <i class="icon icon-arrow-next"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="img_area">
      <!-- <button> -->

      <img
      @click="full_screan = !full_screan"
        :src="images.length > 0 ? images[current_index].url : ''"
        class="rounded"
      />
      <!-- </button> -->
    </div>
    <!-- <div class="img_area">
      <BoxImage class="image" :image="images.length > 0 ? images[current_index].url : ''" />
    </div> -->
  </div>
</template>

<script>
import BoxImage from "./BoxImage.vue";

export default {
  name: "CarrocelImage",
  props: { images: Array },
  components: { BoxImage },
  data() {
    return {
      current_index: 0,
      full_screan: false,
    };
  },
  methods: {
    nextImage() {
      if (this.current_index !== this.images.length - 1) this.current_index++;
    },
    backImage() {
      if (this.current_index !== 0) this.current_index--;
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background-color: rgba($color: #000000, $alpha: 0.4);
  //   background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.5));
  border: none;
  height: 50px;
  width: 50px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  background-color: #ffffff;
  height: 20px;
  width: 20px;
}

.carrocel {
  height: 520px;

  img {
    width: 100%;
    height: 520px;
    object-fit: cover;
  }
}

.carousel_full {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  // background: rosybrown;
  background-color: rgba($color: #000000, $alpha: 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  button{
    border: 1px solid #666666
  }
  img {
     max-width: 900px;
    width: 100%;
    object-fit: cover;
  }
}

.indicators {
  background-color: rgba($color: #000000, $alpha: 0.4);
  padding: 0;
}
.indicator {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  border-radius: 1rem;
}
.selected {
  width: 20px;
}
.ative-area {
  position: absolute;
  padding-right: 2rem;
  width: 100%;
  // height: 28vw;
  height: 100%;
  .btn-area {
    height: 100%;
    display: flex;
    align-items: center;
  }
}

@media (max-width: 1025px) {
  // .carrocel,
  // .ative-area {
  // //   height: 380px;
  // //   img {
  // //     height: 380px;
  // //   }
  // // }
}

@media (max-width: 765px) {
  .btn-full-image{
    display: none;
  }
  // .carrocel,
  // .ative-area {
  //   height: 230px;
  //   img {
  //     height: 230px;
  //   }
  // }
}
</style>
